import { Link } from 'react-router-dom';
import { articles } from '@/mocks/data';
import ArticleCard from '@/components/feature/ArticleCard';

export default function FeaturedSection() {
  const featuredArticles = articles.filter((a) => a.featured).slice(0, 3);
  const trendingArticles = articles.filter((a) => a.trending).slice(0, 3);

  return (
    <section className="w-full px-4 md:px-6 lg:px-8 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="mb-14">
          <div className="flex items-center justify-between mb-8">
            <div>
              <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
                精选推荐
              </h2>
              <p className="text-sm text-foreground-500 mt-2">
                编辑部精心挑选的高质量内容，深度解读里番动漫文化
              </p>
            </div>
            <Link
              to="/category/pure-love"
              className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
            >
              查看全部
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {featuredArticles.map((article) => (
              <ArticleCard key={article.id} {...article} />
            ))}
          </div>
        </div>

        <div>
          <div className="flex items-center justify-between mb-8">
            <div>
              <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
                热门文章
              </h2>
              <p className="text-sm text-foreground-500 mt-2">
                近期最受读者关注的里番动漫相关内容
              </p>
            </div>
            <Link
              to="/category/harem"
              className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
            >
              更多热门
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {trendingArticles.map((article) => (
              <ArticleCard key={article.id} {...article} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}